import client_lookups from '@/assets/json/clientLookups.json'
import { useAuthStore } from '@/stores/auth'
import { useFormStore } from '@/stores/form'
import { notify } from 'notiwind'
import i18n from '@/i18n/i18n'

export default async function () {
  const formStore = useFormStore()
  const authStore = useAuthStore()

  const { complaintReasonesArray, defendantEidaNumber } = formStore.form.values
  const { applicationId } = authStore.user
  const {
    application: { TypingCenter, establishment }
  } = client_lookups

  if (complaintReasonesArray) {
    formStore.draft.request.lookupModuleTransreasIds = complaintReasonesArray.join(',')
  }

  if (applicationId == TypingCenter) {
    // applicantIdentityNumber is coming from the card reader, which isn't implemented yet.
    // if (authManager.getCurrentUser().applicationId == lookups.application.TypingCenter) {
    //   if (
    //     $scope.draft.request.applicantIdentityNumber == $scope.draft.request.defendantEidaNumber
    //   ) {
    //     options = {
    //       type: 'error',
    //       isSticky: true,
    //       messageKey: $translate.instant('IncorectIdentityNumber'),
    //       titleKey: ''
    //     }
    //     notificationsService.showNotification(options)
    //     return
    //   }
    // }
  }

  if (applicationId == establishment) {
    const hasMatch = authStore.establishmentInfo.relatedPerson.some(
      (rp) => defendantEidaNumber == rp.identityNumber
    )

    if (!hasMatch) {
      notify(
        {
          group: 'error',
          title: i18n.global.t('errorSetDefaultAddress'),
          text: i18n.global.t('CorrectIdentityNumber')
        },
        6000
      )

      return Promise.resolve(false)
    }
  }

  return Promise.resolve(true)
}
